module.exports = __webpack_public_path__ + "static/blog-ed697af5bd8d986e5f7240fbe2193b73.jpg";